import axios from 'axios';
import type { RefreshTokenRequest, RefreshTokenResponse } from '@/types/auth.types';

// Kept out of authService.ts: axiosInstance imports this, and authService imports axiosInstance.
export const refreshAccessToken = async (refreshToken: string): Promise<string> => {
  const body: RefreshTokenRequest = { refreshToken };
  const { data } = await axios.post<RefreshTokenResponse>('/auth/refresh', body, {
    baseURL: import.meta.env.VITE_API_URL as string,
  });
  return data.tokens.accessToken;
};
